import { gql } from 'react-apollo';

export const validateToken = gql`
  mutation validateResetPasswordToken($input: ValidateResetPasswordTokenInput!) {
    validateResetPasswordToken(input: $input) {
      email
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/pages/reset_password/mutations/validateToken.js